export default "__VITE_ASSET__CKfrtx13__"